// Calendar-day helpers of the report screen. Report dates are civil days
// (YYYY-MM-DD), so arithmetic runs on UTC midnights; today is the civil day in
// Brazil (America/Sao_Paulo), the same day the backend checks deadlines on.
import type { CalendarDate } from '@finnest/power-admin-contracts/regulatory-reports';

const DAY_MS = 86_400_000;
const ISO_DATE_LENGTH = 10;
const ISO_YEAR_LENGTH = 4;

/** The first year the Relatório do Diretor exists for (Res. CNSP 415/2021). */
export const FIRST_REPORT_YEAR = 2021;

const utcMidnight = (date: string): number => Date.parse(`${date}T00:00:00Z`);

export const formatCalendarDate = (date: string): string =>
  date.replace(/^(\d{4})-(\d{2})-(\d{2})$/u, '$3/$2/$1');

export const formatInstant = (instant: string): string =>
  new Date(instant).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });

export const daysUntil = (from: string, to: string): number =>
  Math.round((utcMidnight(to) - utcMidnight(from)) / DAY_MS);

export const dayBefore = (date: CalendarDate): string =>
  new Date(utcMidnight(date) - DAY_MS).toISOString().slice(0, ISO_DATE_LENGTH);

const SAO_PAULO_DAY = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Sao_Paulo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const todayCalendarDate = (now: Date): string => SAO_PAULO_DAY.format(now);

// The report year of today: the year of the civil day in São Paulo, so the last
// local evening of December still opens that year's report.
export const currentReportYear = (now: Date): number => calendarReportYear(todayCalendarDate(now));

export const calendarReportYear = (today: string): number =>
  Number(today.slice(0, ISO_YEAR_LENGTH));
